<template>
  <div id="app">

    <!-- <transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="router-anim-leave-active"> -->
    <transition-page>
    <router-view/>
    </transition-page>
    <!-- </transition> -->


    <cookie-law>
      <div slot="message">
        <p>Wij gebruiken cookies om ervoor te zorgen dat onze website voor de bezoeker beter werkt. Daarnaast gebruiken wij o.a. cookies voor onze webstatistieken. Bekijk hier onze <router-link to="/privacy-verklaring">Privacy voorwaarden</router-link>.</p>
      </div>
    </cookie-law>
  </div>
</template>

<script>
  
  import Lottie from './lottie.vue';
  import * as animationAvansHogeschool from '@/assets/cases/avanshogeschool/headeranimatie/avanshogeschool.json';
  import navbar from '@/components/generalLayout/navbar.vue';
  import footerComponent from '@/components/specificLayout/footerComponent.vue';
  import CookieLaw from 'vue-cookie-law'
  import TransitionPage from '@/components/specificLayout/TransitionPage.vue';


  export default {
    name: 'app',
    data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationAvansHogeschool.default}, background: 'rgba(255,30,61,0.15)', link: '/werk/avans-hogeschool', string:'Bekijk onze brand new case', },
      ],
       menuOpen:false,
       checkboxValue: false,
    }
  },
  components:{
    'lottie': Lottie,
    navbar,
    footerComponent,
    CookieLaw,
    TransitionPage
  },

  methods:{
       vhFix: function () {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    },
    uncheck(){
        this.checkboxValue = false;
    },

    browsercheck: function(){
      const { detect } = require('detect-browser');
      const browser = detect();
 
      // handle the case where we don't detect the browser
      switch (browser && browser.name) {
  
        case 'ie':
          this.$router.push('noIE') 
          break;

      }
    },
    
    handleScroll: function (evt, el,) {
    if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'background-color: white; box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05), 0 10px 7px 0 rgba(0, 0, 0, 0.02); transition: 0.3s all; height: 100px'
        )
      } else { 
        el.setAttribute(
          'style',
          'background-color: transparant; height: 140px'
      )} 
    },

    handleScrollPartTwo: function (evt, el) {
        
      if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'margin-top: 22px; transition: 0.3s all;'
        )
      } else { 
        el.setAttribute(
           'style',
          'margin-top: 64px; transition: 0.3s all;'
      )} 
    },
    
    handleScrollPartThree: function (evt, el) {

        if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'top: 22px; transition: 0.3s all;'
        )
      } else { 
        el.setAttribute(
          'style',
          'top: 64px; transition: 0.3s all;'
      )} 
    },
  },
  mounted(){
    this.vhFix();
    this.browsercheck();
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },

    watch:{
      $route (to, from){
        this.menuOpen = false;
      },
       menuOpen: function (menuOpen) {
        if (menuOpen) {
          // document.body.style.overflow = 'hidden'

            
        setTimeout(() => {
          var element = document.querySelector('body');
          element.classList.add('noScroll');
          document.body.querySelector('#logo').style.pointerEvents = 'none'

        }, 1500)
          
        } else {
          var element = document.querySelector('body');
          element.classList.remove('noScroll');
          document.body.querySelector('#logo').style.pointerEvents = 'all'
        }
      }
    },
  }  
 
</script>

<style lang="scss">

@import './scss/_base.scss';
@import './scss/_menu.scss';

.noScroll { /* ...or body.dialogShowing */
  overflow: hidden;
}

  .logo-dot{
    background-color: black;
    width: 4px;
    height: 4px;
    border-radius: 100px;
    position: absolute;
    right: 5px;
    top: -9px;
  }

  .navbar{
     height: 140px;
     width: 100%;
     position:fixed;
     z-index: 999;
     transition: 0.3s all;

     .logo-dot{
      z-index: 150;
    }
    
     img{
         max-height: 64px;
         max-width: 140px;
         width: 100%;
         margin-top:layout-val-64(1);
         position: relative;
         z-index: 999;

        &:hover{
          + .logo-dot{
            animation: animate-in 1.5s;
            animation-iteration-count: 99;
            animation-fill-mode: forwards;
        }
      }
      @keyframes animate-in {
        20%,
        50%,
        80%,
        100% {
          transform: translateY(0);
        }
        40% {
          transform: translateY(-10px);
        }
        60% {
          transform: translateY(-5px);
        }
        0% {
          transform: translateY(-1vh);
        }
      }
    }
     .menu-trigger{
         position:absolute;
         right: 64px;
         top:64px;
         float:right;
         z-index: 999;
         p{
             display: inline-block;
             margin-right: layout-val-8(4);
             font-family: $font-stack-copy;
             font-weight: 900;
             opacity: 1;
        }
         .toggle {
             display: inline-block;
             transform: scale(1.5);
             cursor: pointer;
             input {
                 display: none;
                 & + div {
                     width: 20px;
                     height: 14px;
                     position: relative;
                     div {
                         position: absolute;
                         left: 0;
                         top: 0;
                         right: 0;
                         bottom: 0;
                         transition: transform .5s ease;
                         span {
                             display: block;
                             position: absolute;
                             left: 0;
                             right: 0;
                             &:first-child {
                                 top: 0;
                                 &:before, &:after {
                                     top: 0;
                                }
                            }
                             &:last-child {
                                 bottom: 0;
                                 &:before, &:after {
                                     bottom: 0;
                                }
                            }
                             &:before, &:after {
                                 content: '';
                                 display: block;
                                 width: 47%;
                                 height: 2px;
                                 border-radius: 1px;
                                 background: $black;
                                 position: absolute;
                                 -webkit-backface-visibility: hidden;
                                 transition: transform .5s ease, border-radius .3s ease;
                            }
                             &:before {
                                 left: 0;
                                 transform-origin: 0 50%;
                                 transform: translate(1px, 0) scaleX(1.1);
                            }
                             &:after {
                                 right: 0;
                                 transform-origin: 100% 50%;
                                 transform: translate(-1px, 0) scaleX(1.1);
                            }
                        }
                    }
                     svg {
                         display: block;
                         fill: none;
                         stroke: $yellow;
                         stroke-width: 2px;
                         width: 44px;
                         height: 44px;
                         stroke-linecap: round;
                         position: absolute;
                         left: 50%;
                         top: 50%;
                         margin: -22px 0 0 -22px;
                         stroke-dasharray: 0 82.801 8 82.801;
                         stroke-dashoffset: 82.801;
                         transform-origin: 50% 50%;
                         -webkit-backface-visibility: hidden;
                         transform: scale(1);
                         transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease;
                         &:nth-child(3) {
                             transform: rotate(180deg) scale(1);
                        }
                    }
                }
                 &:checked + div {
                     div {
                         transform: rotate(90deg);
                         span {
                             &:first-child {
                                 &:before {
                                     transform: rotate(45deg) translate(2.2px, -3px) scaleX(1.05);
                                }
                                 &:after {
                                     transform: rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05);
                                }
                            }
                             &:last-child {
                                 &:before {
                                     transform: rotate(-45deg) translate(2.2px, 3px) scaleX(1.05);
                                }
                                 &:after {
                                     transform: rotate(45deg) translate(-2.2px, 3px) scaleX(1.05);
                                }
                            }
                        }
                    }
                     svg {
                         stroke-dashoffset: 62;
                         stroke-dasharray: 0 82.801 62 82.801;
                         transform: rotate(90deg);
                         &:nth-child(3) {
                            transform: rotate(270deg);
                        }
                    }

                }
            }
        }
    }
}
 .menu{
     height: 100vh;
     height: calc(var(--vh, 1vh) * 100);
     width: 100vw;
     background: $white;
     position:absolute;
     top:0;
     right: 0;
     opacity: 0;
     pointer-events: none;
     @include transition;
     transition-delay: 1.1s;
     z-index: 99;

     .menu-bg{
        position:absolute;
        left: -100%;
        width: 75%;
        height: 100%;
        border-top: layout-val-8(3) solid $white;
        border-left: layout-val-8(3) solid $white;
        border-bottom: layout-val-8(3) solid $white;
        box-sizing: border-box;
        pointer-events: none;
        @include transition-menu;
        transition-delay: 0.3s;
    }
    .navbar-start{
      opacity: 0;
      @include transition;
    }
    .contact{
      opacity: 0;
      @include transition;
    }
    .animation{
      opacity: 0;
      @include transition;
      max-width: 580px;

        a{
          color: #3E374A;
          font-weight: 900;
          font-family: $font-stack-copy;
        }
    }
}
 .is-open{
  right:0;
  @include transition;
  opacity: 1;
  pointer-events: all;
  position: absolute;

    .menu-bg{
      left: 0;
      background-color:rgba(246,119,78,0.15);
      transition-delay: 0.6s;
    }

    .navbar-start, .contact, .animation{
      opacity: 1;
      transition-delay: 0.8s;
    }
    .animation{
      transition-delay: 1.2s;
    }
}

@media screen and (max-width: 1160px) {
  .content-grid-two-rows .column{
    width: 80%;
  }
}

@media screen and (max-width: 860px) {
  .case{
  img{
    max-width: 400px !important;
  }
}
}

@media screen and (max-width: 720px) {
  body .work-we-love ul li {
    width: 100% !important;
  }
 body .content-grid-two-rows .column{
    width: 100%;
    margin-bottom: layout-val-8(4) !important;
    margin: 0 auto;
  }
}

@media screen and (max-width: 640px) {
  .icon-grid{
    flex-direction: column-reverse;
  }
  .icon-box{
    width: 100%;
    margin: 0 auto;
    margin-bottom: layout-val-8(4) !important;
  }
  .container{
    padding-left: layout-val-8(2.5);
    padding-right: layout-val-8(2.5);
  }
  .case-content{
    .intro-tekst{
      padding-left: layout-val-8(2);
      padding-right: layout-val-8(2);
    }
  }
  .home-bg-color{
    width: 100% !important;
    border-right: 24px solid $white;
  }
  .navbar{
    height: 90px !important;
    background: $white;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05), 0 10px 7px 0 rgba(0, 0, 0, 0.02);
      img{
        margin-top:24px !important;
        padding-left: 0px;
        left:0;
        max-width: 110px;

          &:hover{
          + .logo-dot{
            animation:none;
        }
          }
        
      }
      .menu-trigger{
        top:24px !important;
        right: 32px;
      }
      .logo-dot{
        right: -1px;
      }
  }

  .who-are-we{
    padding: 64px 32px !important;
  }
  .fold-container .home-bg-color, .fold-container .home-bg-color-change{
    max-width: 100% !important;
    border-right: 24px solid $white;
    border-left: 24px solid $white;
    right: 0;
    left:0;
    border-top: 120px solid $white;
    box-sizing: border-box;
  }
  .menu .menu-bg{
    border-top: 120px solid $white;
  }

  .animation{
    width: 80%;
    margin: 0 auto;
    position: relative;
    
  }
}

@media screen and (max-width: 480px) {
  .fold-container{
    height: 80vh;
    height: calc(var(--vh, 1vh) * 80);
    padding-top:35px;
  }
  .animation{
    margin-top: 20%;
  }
  .who-are-we{
    padding-top:40px !important;
  }
}


     

</style>